import { render, staticRenderFns } from "./NuevoTipoEntrada.vue?vue&type=template&id=b42157a0"
import script from "./NuevoTipoEntrada.vue?vue&type=script&lang=js"
export * from "./NuevoTipoEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports